let isTokenExpired = false;

export const getIsTokenExpired = () => {
    return isTokenExpired;
};

export const setIsTokenExpired = (isExpired: boolean) => {
    isTokenExpired = isExpired;
};
